<template>
  <DropdownMenuPicker :popper-class="$style.Panel__Popper" :disabled="!isLogined" v-bind="$attrs">
    <div :class="$style.Message" @click="handleClickIcon">
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :class="['svgfont', $style.Message__Icon]"
      >
        <g clip-path="url(#clip0_74486_316)">
          <mask
            id="mask0_74486_316"
            style="mask-type: luminance"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="20"
            height="20"
          >
            <path d="M20 0H0V20H20V0Z" fill="white" />
          </mask>
          <g mask="url(#mask0_74486_316)">
            <path
              d="M10 10.625C9.875 10.625 9.75 10.625 9.6875 10.5625L4.6875 7.6875L5.3125 6.625L10 9.3125L14.6875 6.625L15.3125 7.6875L10.3125 10.5625C10.25 10.625 10.125 10.625 10 10.625Z"
            />
          </g>
          <mask
            id="mask1_74486_316"
            style="mask-type: luminance"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="20"
            height="20"
          >
            <path d="M20 0H0V20H20V0Z" fill="white" />
          </mask>
          <g mask="url(#mask1_74486_316)">
            <path
              d="M17.5 5V15H2.5V5H17.5ZM17.5 3.75H2.5C1.8125 3.75 1.25 4.3125 1.25 5V15C1.25 15.6875 1.8125 16.25 2.5 16.25H17.5C18.1875 16.25 18.75 15.6875 18.75 15V5C18.75 4.3125 18.1875 3.75 17.5 3.75Z"
            />
          </g>
        </g>
        <defs>
          <clipPath id="clip0_74486_316">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
      <span :class="[$style.CountDot, $style.Message__Count]" v-show="badgeCount > 0">{{
        `${badgeCount > 99 ? `99+` : `${badgeCount}`}`
      }}</span>
    </div>
    <template #content>
      <div :class="['flex flex-col py-1 border-0 border-t border-solid bm-bd-gray-200', $style.Panel__Wrapper]">
        <MessageClazzItem v-for="(item, i) in msgClazzList" :key="i" :item="item" />
      </div>
    </template>
  </DropdownMenuPicker>
</template>
<script lang="ts">
import DropdownMenuPicker from '../DropdownMenuPicker.vue';
import { computed, watch } from 'vue';
import MessageClazzItem from './MessageClazzItem.vue';
import { IMsgClazzItem } from './types';
import { isLoginedToken } from '~/common/js/utils';
import { useStore } from '~/common/js/patch';
import { axiosClient } from '~/common/js/axios';

// import { useStore, useRouter } from '@nuxtjs/composition-api';
export default {
  components: {
    DropdownMenuPicker,
    MessageClazzItem,
  },
  props: {},
  setup() {
    // eslint-disable-next-line
    const router = useRouter();
    const store = useStore() as any;
    const msgClazzList = computed<IMsgClazzItem[]>(() => {
      return store.state.msgStationClazzList || [];
    });
    const locale = computed<IMsgClazzItem[]>(() => {
      return store.state.locale || 'en';
    });

    const badgeCount = computed<number>(() => {
      let count = 0;
      msgClazzList.value.forEach((item: IMsgClazzItem) => {
        count += item.unreadCount;
      });
      return count;
    });
    const handleClickIcon = () => {
      if (!isLoginedToken()) {
        router.push({
          path: '/login',
          query: {
            goto: 'messages-lang',
          },
        });
      } else {
        router.push({
          path: '/messages',
        });
      }
    };
    const isLogined = computed<boolean>(() => {
      return !!store.state.account.loginName;
    });
    const requestSync = () => {
      if (!isLoginedToken()) {
        return;
      }
      axiosClient({
        url: '/gw-api/notification/msg/station/sync',
        method: 'POST',
      });
    };
    watch(
      [isLogined, locale],
      () => {
        if (!process.client || !isLogined.value) {
          return;
        }
        store.dispatch('setMsgStationClazz', {});
        requestSync();
      },
      { immediate: true }
    );
    return {
      msgClazzList,
      badgeCount,
      handleClickIcon,
      isLogined,
    };
  },
};
</script>

<style lang="less" module>
@import '@/frontend-shared/components/NavigatorBar/assets/css/ui.variables.less';
@item_height: 72px;

.Panel {
  &__Popper {
    width: 360px !important;
    scrollbar-width: auto;
    scrollbar-color: rgba(0, 0, 0, 0.3);
  }
  &__Wrapper {
    max-height: calc(@item_height * 5);
  }
}

.Message {
  display: flex;
  align-items: center;
  position: relative;
  &__Count {
    position: absolute;
    top: 2px;
    right: -1px;
    transform: translate(50%, -50%);
  }
  &__Icon {
    font-size: 20px;
  }
}
.CountDot {
  display: block;
  color: #ffffff;
  background-color: #ff532f;
  border-radius: 30px;
  line-height: 12px;
  font-size: 10px;
  padding: 1px 5px;
  min-width: 24px;
  text-align: center;
  box-sizing: border-box;
  height: 14px;
}
</style>
